import { ca } from '@cian/analytics';

export function trackPageview(eventData: {}) {
  ca('pageviewSite', eventData);
}
